export default [
  {
    name: 'flowTask',
    path: '/flowCenter/task',
    meta: {
      name: '审核',
    },
    component: () => import('@/page/main/flowCenter/task'),
  },
  {
    name: 'flowDone',
    path: '/flowCenter/done',
    meta: {
      name: '已办',
    },
    component: () => import('@/page/main/flowCenter/done'),
  },
  {
    name: 'flowInst',
    path: '/flowCenter/flowInst',
    meta: {
      name: '实例',
    },
    component: () => import('@/page/main/flowCenter/inst'),
  },
  {
    name: 'flowRead',
    path: '/flowCenter/read',
    meta: {
      name: '待阅',
    },
    component: () => import('@/page/main/flowCenter/read'),
  },
  {
    name: 'flowReadDone',
    path: '/flowCenter/readDone',
    meta: {
      name: '已阅',
    },
    component: () => import('@/page/main/flowCenter/read'),
  },
]
